import {
    enum_moveToOptions,
    enum_questCategories,
    enum_questLocationsTypes_s as enum_questLocations_s
} from "../../functions/src/shareCode/Share_S_Enum";
import {gv_strings} from "./S_GlobalVar";
import {enum_langCodes} from "../../functions/src/shareCode/Share_S_Enum";
import {ass_strings} from "../../functions/src/shareCode/Share_Ass_Dictionary";
import {format_date_input_fs} from "../../functions/src/shareCode/Share_S_Format";

let defaultImgUrl_s = 'https://travelquest.xyz/img/icons/logo-full-256x256.jpg'

let seoInfo_byPathName_o = {

    // player
    [enum_moveToOptions.player_play_list] : {
        title_blc_s         : ass_strings.oneWord_play,
        description_blc_s   : ass_strings.sentence_description_playerTickets,
        robots              : "index, follow",
        img_s               : defaultImgUrl_s
    },
    [enum_moveToOptions.player_play_entry_ticket] : {
        title_blc_s         : ass_strings.oneWord_play,
        description_blc_s   : ass_strings.sentence_description_playerTickets,
        robots              : "noindex, nofollow",
        img_s               : defaultImgUrl_s
    },

    [enum_moveToOptions.player_store] : {
        title_blc_s         : ass_strings.oneWord_store,
        description_blc_s   : ass_strings.sentence_description_playerExploreList,
        robots              : "index, follow",
        img_s               : defaultImgUrl_s
    },
    [enum_moveToOptions.player_store_quest] : {
        title_blc_s         : ass_strings.oneWord_quest,
        description_blc_s   : ass_strings.oneWord_quest,
        robots              : "index, follow",
        img_s               : defaultImgUrl_s,
        dynamicSeo_b        : true,
    },
    [enum_moveToOptions.player_store_creator] : {
        title_blc_s         : ass_strings.oneWord_quest,
        description_blc_s   : "",
        robots              : "index, follow",
        img_s               : defaultImgUrl_s,
        dynamicSeo_b        : true,
    },
    [enum_moveToOptions.player_store_category] : {
        title_blc_s         : ass_strings.oneWord_quest,
        description_blc_s   : "",
        robots              : "index, follow",
        img_s               : defaultImgUrl_s,
        dynamicSeo_b        : true,
    },


    [enum_moveToOptions.player_profile] : {
        title_blc_s         : ass_strings.oneWord_profile,
        description_blc_s   : ass_strings.sentence_description_playerProfile,
        robots              : "index, follow",
        img_s               : defaultImgUrl_s
    },

    // terms
    [enum_moveToOptions.terms_creatorPolicy] : {
        title_blc_s         : ass_strings.twoWords_creatorTerms,
        description_blc_s   : ass_strings.twoWords_creatorTerms,
        robots              : "index, follow",
        img_s               : defaultImgUrl_s
    },
    [enum_moveToOptions.terms_disclaimer] : {
        title_blc_s         : ass_strings.oneWord_disclaimer,
        description_blc_s   : ass_strings.oneWord_disclaimer,
        robots              : "index, follow",
        img_s               : defaultImgUrl_s
    },
    [enum_moveToOptions.terms_cookiePolicy] : {
        title_blc_s         : ass_strings.twoWords_cookiePolicy,
        description_blc_s   : ass_strings.twoWords_cookiePolicy,
        robots              : "index, follow",
        img_s               : defaultImgUrl_s
    },
    [enum_moveToOptions.terms_termsOfUse] : {
        title_blc_s         : ass_strings.threeWords_termsOfUse,
        description_blc_s   : ass_strings.threeWords_termsOfUse,
        robots              : "index, follow",
        img_s               : defaultImgUrl_s
    },
    [enum_moveToOptions.terms_privacyPolicy] : {
        title_blc_s         : ass_strings.twoWords_privacyPolicy,
        description_blc_s   : ass_strings.oneWord_about,
        robots              : "index, follow",
        img_s               : defaultImgUrl_s
    },

    // stand along
    [enum_moveToOptions.standAlong_about] : {
        title_blc_s         : ass_strings.oneWord_about,
        description_blc_s   : ass_strings.sentenceGroup_about1,
        robots              : "index, follow",
        img_s               : defaultImgUrl_s
    },


    // note index
    [enum_moveToOptions.creator] : {
        title_blc_s         : ass_strings.oneWord_creator,
        description_blc_s   : ass_strings.sentence_description_generic,
        robots              : "noindex, nofollow",
        img_s               : defaultImgUrl_s
    },
    [enum_moveToOptions.admin] : {
        title_blc_s         : ass_strings.oneWord_admin,
        description_blc_s   : ass_strings.sentence_description_generic,
        robots              : "noindex, nofollow",
        img_s               : defaultImgUrl_s
    },
    [enum_moveToOptions.ongoing] : {
        title_blc_s         : ass_strings.oneWord_ongoing,
        description_blc_s   : ass_strings.sentence_description_generic,
        robots              : "noindex, nofollow",
        img_s               : defaultImgUrl_s
    },
}

// seo_updateLang_f
const seo_updateLang_f = (langCode_es) =>  {

    if(langCode_es === enum_langCodes.hebrew){
        langCode_es = gv_strings.hebrewCode
    }

    if(document.documentElement.lang !== langCode_es){
        document.documentElement.lang = langCode_es
    }
}

// seo_updateDynamicValues_f
export const seo_updateDynamicValues_f = ({title_s, description_s, imagePath_s}) => {
    if(title_s){
        // let newTitle_s = document.title + " | " + title_s
        document.title = title_s
        document.getElementsByName("og:title")[0].content = title_s;
    }
    if(description_s){
        document.getElementsByName("description")[0].content = description_s;
        document.getElementsByName("og:description")[0].content = description_s;
        document.getElementsByName("twitter:description")[0].content = description_s;
    }
    if(imagePath_s){
        document.getElementsByName("ogImage")[0].content = imagePath_s
        document.getElementsByName("twitter:image")[0].content = imagePath_s
        document.getElementsByName("twitter:card")[0].content = imagePath_s
    }
}

// seo_updateMeta_f
export const seo_updateMeta_f = ({path_s, langCode_es}) => {

    seo_updateLang_f(langCode_es)

    let pathAfterLangCode_e = path_s.substring(3)

    let seoInfo_o = seoInfo_byPathName_o[pathAfterLangCode_e]

    if(pathAfterLangCode_e.includes(enum_moveToOptions.player_store_quest)){
        seoInfo_o = seoInfo_byPathName_o[enum_moveToOptions.player_store_quest]
    }

    // if(pathAfterLangCode_e.includes(enum_moveToOptions.player_blog_item)){
    //     seoInfo_o = seoInfo_byPathName_o[enum_moveToOptions.player_blog_item]
    // }

    if(pathAfterLangCode_e.includes(enum_moveToOptions.player_store_category)){
        seoInfo_o = seoInfo_byPathName_o[enum_moveToOptions.player_store_category]
    }

    if(pathAfterLangCode_e === ''){
        seoInfo_o = seoInfo_byPathName_o[enum_moveToOptions.player_play_list]
    }

    if(seoInfo_o){
        document.title = seoInfo_o.title_blc_s[langCode_es]
        document.getElementsByName("og:title")[0].content = seoInfo_o.title_blc_s[langCode_es]

        document.getElementsByName("description")[0].content = seoInfo_o.description_blc_s[langCode_es]
        document.getElementsByName("og:description")[0].content = seoInfo_o.description_blc_s[langCode_es]
        document.getElementsByName("twitter:description")[0].content = seoInfo_o.description_blc_s[langCode_es]

        document.getElementsByName("ogImage")[0].content = seoInfo_o.img_s
        document.getElementsByName("twitter:image")[0].content = seoInfo_o.img_s
        document.getElementsByName("twitter:card")[0].content = seoInfo_o.img_s

        document.getElementsByName("robots")[0].content=seoInfo_o.robots
    }else{
        document.title = ass_strings.twoWords_travelQuest[langCode_es]
        document.getElementsByName("og:title")[0].content = ass_strings.twoWords_travelQuest[langCode_es]

        document.getElementsByName("description")[0].content = ass_strings.sentence_description_generic[langCode_es]
        document.getElementsByName("og:description")[0].content = ass_strings.sentence_description_generic[langCode_es]
        document.getElementsByName("twitter:description")[0].content = ass_strings.sentence_description_generic[langCode_es]

        document.getElementsByName("ogImage")[0].content = defaultImgUrl_s
        document.getElementsByName("twitter:image")[0].content = defaultImgUrl_s
        document.getElementsByName("twitter:card")[0].content = defaultImgUrl_s

        document.getElementsByName("robots")[0].content="noindex, nofollow"

    }



}

// route_creatSiteMap_f
export const seo_creatSiteMap_f = (creatorsData_ac, creatorMoreInfo_byId_c, questExplore_ac, articlesData_ac) => {
    let siteMapXml_s = ''
    let routers_as = []
    siteMapXml_s+=`<?xml version="1.0" encoding="UTF-8"?>\n`
    siteMapXml_s+=`<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xhtml="http://www.w3.org/1999/xhtml">\n`

    for(let route_s in seoInfo_byPathName_o){

        if(seoInfo_byPathName_o[route_s].robots.includes('noindex')){
            continue
        }
        if(seoInfo_byPathName_o[route_s].dynamicSeo_b){
            continue
        }

        let length_n = route_s.length
        if(route_s[length_n-1] === '/'){
            route_s = route_s.substring(0, length_n-1)
        }

        siteMapXml_s+= addRoute_fs(route_s, Object.values(enum_langCodes), routers_as)

    }

    // questCategories
    for(let key in enum_questCategories){
        let questCategory_s =  enum_questCategories[key]
        let categoryPath_s = enum_moveToOptions.player_store_category + "/" + questCategory_s
        siteMapXml_s+= addRoute_fs(categoryPath_s, Object.values(enum_langCodes), routers_as)
    }

    // articlesData_ac
    articlesData_ac.forEach(articlesData_c => {
        let storePath_s = enum_moveToOptions.player_blog_item + "/" + articlesData_c.ba_articleId_uid
        let langCodes_ae = articlesData_c.ba_langArr_ae

        siteMapXml_s+= addRoute_fs(storePath_s, langCodes_ae, routers_as)
    })

    // questsPaths
    questExplore_ac.forEach(questExplore_c => {
        let storePath_s = enum_moveToOptions.player_store_quest + "/" + questExplore_c.qex_questId_uid
        siteMapXml_s+= addRoute_fs(storePath_s, questExplore_c.qex_langArr_ae, routers_as)

        let categories_as = []
        if (questExplore_c.qex_metadata_c.qexm_questLocationType_e === enum_questLocations_s.outside){
            categories_as.push(enum_questCategories.outside)
        }else{
            categories_as.push(enum_questCategories.virtual)
        }

        if (questExplore_c.qex_metadata_c.qexm_guide_b){
            categories_as.push(enum_questCategories.teamWork)
        }else{
            categories_as.push(enum_questCategories.selfGuided)
        }

        categories_as.forEach(category_s => {
            let categoryPath_s = enum_moveToOptions.player_store_category + "/" + category_s + '/' + questExplore_c.qex_questId_uid
            siteMapXml_s+= addRoute_fs(categoryPath_s, questExplore_c.qex_langArr_ae, routers_as)
        })

    })

    // creatorsPages
    creatorsData_ac.forEach(creatorData_c => {
        let storePath_s = enum_moveToOptions.player_store_creator + "/" + creatorData_c.ud_m_getUrlFromEmail_fs()
        let langCodes_ae = creatorMoreInfo_byId_c[creatorData_c.ud_userId_uid].udsmi_langArr_ae


        siteMapXml_s+= addRoute_fs(storePath_s, langCodes_ae, routers_as)
    })

    siteMapXml_s+= `</urlset>`

    console.log(siteMapXml_s)
    console.log(JSON.stringify(routers_as))

}
const addRoute_fs = (routeSuffix_s, langCodes_ae, routers_as) => {
    let siteMapXml_s = ''

    siteMapXml_s+=`    <url>\n`
    siteMapXml_s+=`       <loc>https://travelQuest.xyz/${langCodes_ae[0]}${routeSuffix_s}</loc>\n`

    // fixPaths
    for(let index_n in langCodes_ae){
        let langCode_e = langCodes_ae[index_n]
        let herfLang_e =  langCode_e

        if(langCode_e === enum_langCodes.hebrew){
            herfLang_e = gv_strings.hebrewCode
        }

        let relativePath_s = `/${langCode_e}${routeSuffix_s}`
        if(relativePath_s[relativePath_s.length-1] === '/'){
            relativePath_s = relativePath_s.substring(0, relativePath_s.length-1)
        }
        routers_as.push(relativePath_s)
        siteMapXml_s+=`        <xhtml:link rel="alternate" hreflang="${herfLang_e}" href="https://travelQuest.xyz${relativePath_s}" />\n`
    }

    siteMapXml_s+=`      <lastmod>${ format_date_input_fs((new Date()).getTime())}</lastmod>\n`
    siteMapXml_s+=`    </url>\n`

    return siteMapXml_s
}
